import { Space } from "antd";

import { withPointerCursor } from "./factory";

export const PointerCursorSpace = withPointerCursor(Space);
